/**
 * Created by untitled on 11/04/2017.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import scrollIntoView from 'scroll-into-view';
import styles from './sharedBreadcrumbs.scss';

const SharedBreadcrumb = ({ displayName, path, index, onClick }) => (
    <a
        data-tn="breadcrumb-item"
        data-index={index}
        href={path}
        className={styles.link}
        onClick={onClick}
    >
        {displayName}
    </a>
);

SharedBreadcrumb.propTypes = {
    displayName: PropTypes.string.isRequired,
    path: PropTypes.string,
    index: PropTypes.number,
    onClick: PropTypes.func,
};

const SharedBreadcrumbLastItem = ({ displayName }) => (
    <span data-tn="breadcrumb-item-last" className={styles.lastItem}>
        {displayName}
    </span>
);

SharedBreadcrumbLastItem.propTypes = {
    displayName: PropTypes.string.isRequired,
};

const scrollToEnd = (el, duration = 1000) => {
    const lastItem = el.querySelector(`.${styles.lastItem}`);
    scrollIntoView(lastItem, {
        time: duration,
    });
};

export class SharedBreadcrumbs extends Component {
    componentDidUpdate({ animate, duration }) {
        if (animate) {
            scrollToEnd(this.wrapper, duration);
        }
    }

    render() {
        const { breadcrumbs, onClick, isLastItemActive } = this.props;
        return (
            <div
                ref={el => {
                    this.wrapper = el;
                }}
                className={styles.wrapper}
                data-tn="breadcrumbs"
            >
                {breadcrumbs.map((breadcrumb, i) => {
                    const { displayName, path } = breadcrumb;
                    const key = `${displayName}${i}`;
                    const lastItem = breadcrumbs.length === i + 1;
                    return lastItem && !isLastItemActive ? (
                        <SharedBreadcrumbLastItem key={key} displayName={displayName} />
                    ) : (
                        <SharedBreadcrumb
                            key={key}
                            index={i}
                            displayName={displayName}
                            path={path}
                            onClick={onClick}
                        />
                    );
                })}
            </div>
        );
    }
}

SharedBreadcrumbs.defaultProps = {
    breadcrumbs: [],
    isLastItemActive: false,
    onClick: () => {},
};

SharedBreadcrumbs.propTypes = {
    breadcrumbs: PropTypes.arrayOf(
        PropTypes.shape({
            displayName: PropTypes.node.isRequired,
            path: PropTypes.string,
        })
    ),
    animate: PropTypes.bool,
    duration: PropTypes.number,
    onClick: PropTypes.func,
    isLastItemActive: PropTypes.bool,
};
